export function fetchDescripcionIA() {
    const container = document.getElementById('descripcion-ia-container');
    const loading = document.getElementById('loading-descripcion');
    const content = document.getElementById('descripcion-ia-content');
    const errorMsg = document.getElementById('descripcion-error');

    fetch(DESC_URL)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            if (data.estado_ok) {
                renderDescripcionIA(data, content);
                loading.style.display = 'none';
                content.style.display = 'block';
            } else {
                // No hay datos disponibles
                loading.style.display = 'none';
                container.style.display = 'none';
            }
        })
        .catch(error => {
            console.error('Error fetching IA description:', error);
            loading.style.display = 'none';
            errorMsg.style.display = 'block';
        });
}

window.fetchDescripcionIA = fetchDescripcionIA;

export function renderDescripcionIA(data, container) {
    let html = '<h3>Información sobre la zona</h3>';
    
    if (data.descripcion_zona) {
        html += `<div class="descripcion-zona">${data.descripcion_zona}</div>`;
    }
    
    if (data.lugares_paqueteria && data.lugares_paqueteria.length > 0) {
        html += '<h4>Lugares de paquetería:</h4><ul class="lugares-paqueteria">';
        data.lugares_paqueteria.forEach(lugar => {
            html += '<li>';
            if (lugar.nombre) html += `<strong>${lugar.nombre}</strong>`;
            if (lugar.direccion) html += `<p>${lugar.direccion}</p>`;
            if (lugar.horario) html += `<small>Horario: ${lugar.horario}</small>`;
            html += '</li>';
        });
        html += '</ul>';
    }
    
    if (data.fecha_actualizacion) {
        html += `<div class="fecha-actualizacion"><small>Actualizado: ${data.fecha_actualizacion}</small></div>`;
    }
    
    container.innerHTML = html;
}